import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

export interface ProposalData {
  job: string;
  reason: string;
}

@Component({
  selector: 'app-proposal-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './proposal-modal.component.html',
  styleUrl: './proposal-modal.component.scss',
})
export class ProposalModalComponent {
  @Input() isOpen = false;
  @Input() candidateName = '';
  @Output() close = new EventEmitter<void>();
  @Output() submit = new EventEmitter<ProposalData>();

  selectedJob = '';
  reason = '';

  jobOptions = [
    'Software Engineer',
    'Senior Software Engineer',
    'Lead Developer',
    'Product Manager',
    'Project Manager',
    'UI/UX Designer',
    'Data Analyst',
    'DevOps Engineer',
  ];

  onClose() {
    this.close.emit();
    this.resetForm();
  }

  onSubmit() {
    if (this.selectedJob && this.reason.trim()) {
      this.submit.emit({
        job: this.selectedJob,
        reason: this.reason.trim(),
      });
      this.resetForm();
    }
  }

  onCancel() {
    this.onClose();
  }

  private resetForm() {
    this.selectedJob = '';
    this.reason = '';
  }

  onBackdropClick(event: Event) {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }
}
